import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user") || "null");

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!allowedRoles.includes(Number(user.role_id))) {
    const message = encodeURIComponent(
      "Vous n'avez pas les droits nécessaires pour accéder à cette page."
    );

    return <Navigate to={`/error?error=${message}`} replace />;
  }

  return children;
};

export default ProtectedRoute;